import { useMutation, useQueryClient } from "@tanstack/react-query"
import { importFertilizerFile } from "./importFertilizerFile";

export const useImportFertilizerFile = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: importFertilizerFile,
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["fertilizers"]
            });
        }
    })
}